import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import OnTokenizeSuccess from './onTokenizeSuccess.mdx';
import OnCheckoutComplete from './onCheckoutComplete.mdx';
import OnBeforePaymentCreate from './onBeforePaymentCreate.mdx';
import PaymentMethodOptions from './paymentMethodOptions.mdx';
import OnResumeSuccess from './onResumeSuccess.mdx';
import OnResumeSuccessHeadless from './onResumeSuccessHeadless.mdx';
import OnResumePending from './onResumePending.mdx';
import OnCheckoutReceivedAdditionalInfo from './onCheckoutReceivedAdditionalInfo.mdx';
import OnCheckoutAdditionalInfo from './onCheckoutAdditionalInfo.mdx';
import OnError from './onError.mdx';
import OnErrorUniversal from './onErrorUniversal.mdx';
import PaymentHandling from './paymentHandling.mdx';
import LocaleData from './localeData.mdx';
import InitScreenEnabledDesc from './initScreenEnabledDesc.mdx';
import SuccessScreenEnabledDesc from './successScreenEnabledDesc.mdx';
import ErrorScreenEnabledDesc from './errorScreenEnabledDesc.mdx';
import ClientSessionCachingEnabledRN from './clientSessionCachingEnabled.mdx';
import ApiVersionRN from './apiVersion.mdx';
import DropInDismissalMechanismDescription from '../../_common/dropInDismissalMechanismDescription.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const ConfigurePaymentMethodType = makeShortcode("ConfigurePaymentMethodType");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`⚠️ If no settings are provided, the SDK will initialize with its default settings. `}<br />{`
Use `}<inlineCode parentName="p">{`PrimerSettings`}</inlineCode>{` to provide different options based on your use case.`}</p>
    <Group mdxType="Group">
  <Item title='paymentHandling' subtitle='String' label='optional' mdxType="Item">
    <PaymentHandling mdxType="PaymentHandling" />
  </Item>
  <Item title='localeData' subtitle='IPrimerLocaleData' label='optional' mdxType="Item">
    {"Forces some payment methods' locale."}
    <LocaleData mdxType="LocaleData" />
  </Item>
  <Item title='paymentMethodOptions' subtitle='IPrimerPaymentMethodOptions' label='optional' mdxType="Item">
    <PaymentMethodOptions mdxType="PaymentMethodOptions" />
  </Item>
  <Item title='uiOptions' subtitle='IPrimerUIOptions' label='optional' mdxType="Item">
        <Group summary='Properties' mdxType="Group">
          <Item title='isInitScreenEnabled' subtitle='Boolean' label='optional' mdxType="Item">
            <InitScreenEnabledDesc mdxType="InitScreenEnabledDesc" />
          </Item>
          <Item title='isSuccessScreenEnabled' subtitle='Boolean' label='optional' mdxType="Item">
            <SuccessScreenEnabledDesc mdxType="SuccessScreenEnabledDesc" />
          </Item>
          <Item title='isErrorScreenEnabled' subtitle='Boolean' label='optional' mdxType="Item">
            <ErrorScreenEnabledDesc mdxType="ErrorScreenEnabledDesc" />
          </Item>
          <Item title='dismissalMechanism' subtitle='DismissalMechanism[]' label='Default: [gestures]' mdxType="Item">
            <DropInDismissalMechanismDescription mdxType="DropInDismissalMechanismDescription" />
          </Item>
          <Item title='theme' subtitle='IPrimerTheme' label='optional' mdxType="Item">
            {'Set a custom theme for Primer SDK.'}
          </Item>
        </Group>
  </Item>
  <Item title='debugOptions' subtitle='IPrimerDebugOptions' label='optional' mdxType="Item">
        <Group summary='Properties' mdxType="Group">
          <Item title='is3DSSanityCheckEnabled' subtitle='Boolean' label='optional' mdxType="Item">
            {'Debug option on 3DS for Primer SDK.'}
          </Item>
        </Group>
  </Item>
	<Item title='clientSessionCachingEnabled' subtitle='boolean' label='optional' mdxType="Item">
		<ClientSessionCachingEnabledRN mdxType="ClientSessionCachingEnabledRN" />
	</Item>
  <Item title='apiVersion' subtitle='PrimerApiVersion' label='optional' mdxType="Item">
		<ApiVersionRN mdxType="ApiVersionRN" />
	</Item>
  <Item title='onBeforeClientSessionUpdate' subtitle='() => void' label='optional' mdxType="Item">
    {'Called when the client session is in the process of being updated. Use it to show a loading indicator on your UI.'}
  </Item>
  <Item title='onClientSessionUpdate' subtitle='(clientSession: PrimerClientSession) => void' label='optional' mdxType="Item">
    {'Called when the client session has been updated by the checkout. Returns the updated client session which can be used to inform your UI. For example updating tax, shipping or discount amounts displayed to your customers.'}
  </Item>
  <Item title='onBeforePaymentCreate' subtitle='(checkoutPaymentMethodData: PrimerCheckoutPaymentMethodData, handler: PrimerPaymentCreationHandler) => void' label='optional' mdxType="Item">
    <OnBeforePaymentCreate mdxType="OnBeforePaymentCreate" />
  </Item>
  <Item title='onCheckoutComplete' subtitle='(checkoutData: PrimerCheckoutData) => void' label='optional' mdxType="Item">
    <OnCheckoutComplete mdxType="OnCheckoutComplete" />
  </Item>
  <Item title='onTokenizeSuccess' subtitle='(paymentMethodTokenData: PrimerPaymentMethodTokenData, handler: PrimerTokenizationHandler) => void' label='optional' mdxType="Item">
    <OnTokenizeSuccess mdxType="OnTokenizeSuccess" />
  </Item>
  <Item title='onResumeSuccess' subtitle='(resumeToken: string, handler: PrimerResumeHandler) => void' label='optional' mdxType="Item">
    <OnResumeSuccess mdxType="OnResumeSuccess" />
  </Item>
  <Item title='onResumePending' subtitle='(additionalInfo: PrimerCheckoutAdditionalInfo) => void' label='optional' mdxType="Item">
    <OnResumePending mdxType="OnResumePending" />
  </Item>
  <Item title='onCheckoutReceivedAdditionalInfo' subtitle='(additionalInfo: PrimerCheckoutAdditionalInfo) => void' label='optional' mdxType="Item">
    <OnCheckoutReceivedAdditionalInfo mdxType="OnCheckoutReceivedAdditionalInfo" />
  </Item>
  <Item title='onError' subtitle='(error: PrimerError, checkoutData: PrimerCheckoutData | null, handler: PrimerErrorHandler | undefined) => void' label='optional' mdxType="Item">
    <OnError mdxType="OnError" />
  </Item>
  <Item title='onDismiss' subtitle='() => void' label='optional' mdxType="Item">
    This method will be called to notify you that the Primer SDK has been dismissed.
  </Item>
  <Item title='headlessUniversalCheckoutCallbacks' subtitle='object' mdxType="Item">
    <Group summary='properties' mdxType="Group">
      <Item title='onAvailablePaymentMethodsLoad' subtitle='(availablePaymentMethods: any[]) => void' mdxType="Item">
          Called when the available payment methods have been loaded. Takes an array of objects as its argument.
          <Group summary='Parameters' mdxType="Group">
                  <Item title='paymentMethods' subtitle='PaymentMethodInfo[]' mdxType="Item">
                          <Group summary='Properties' mdxType="Group">
                                  <Item title='type' subtitle='PaymentMethodType' label='Required' mdxType="Item">
                                          <ConfigurePaymentMethodType mdxType="ConfigurePaymentMethodType" />
                                  </Item>
                                  <Item title='managerType' subtitle='"CARD" | "NATIVE" | "REDIRECT"' label='Required' mdxType="Item">
                                          The type of payment manager to use.
                                  </Item>
                          </Group>
                  </Item>
          </Group>
      </Item>
      <Item title='onTokenizationStart' subtitle='(paymentMethodType: string) => void' mdxType="Item">
        This method will be called with just before the tokenization gets started.
        <Group summary='attributes' mdxType="Group">
            <Item title='paymentMethodType' subtitle='String' label='Required' mdxType="Item" />
        </Group>
      </Item>
      <Item title='onTokenizationSuccess' subtitle='(paymentMethodTokenData: PrimerPaymentMethodTokenData, handler: PrimerHeadlessUniversalCheckoutResumeHandler) => void' mdxType="Item">
        This method will be called when the tokenization was successful.
      </Item>
      <Item title='onCheckoutResume' subtitle='(resumeToken: string, handler: PrimerHeadlessUniversalCheckoutResumeHandler) => void' mdxType="Item">
        <OnResumeSuccessHeadless mdxType="OnResumeSuccessHeadless" />
      </Item>
      <Item title='onCheckoutPending' subtitle='(additionalInfo: PrimerCheckoutAdditionalInfo) => void' mdxType="Item">
        <OnResumePending mdxType="OnResumePending" />
      </Item>
      <Item title='onCheckoutAdditionalInfo' subtitle='(additionalInfo: PrimerCheckoutAdditionalInfo) => void' mdxType="Item">
        <OnCheckoutReceivedAdditionalInfo mdxType="OnCheckoutReceivedAdditionalInfo" />
      </Item>
      <Item title='onError' subtitle='(error: PrimerError, checkoutData: PrimerCheckoutData | null) => void' mdxType="Item">
        <OnErrorUniversal mdxType="OnErrorUniversal" />
      </Item>
      <Item title='onCheckoutComplete' subtitle='(checkoutData: PrimerCheckoutData) => void' mdxType="Item">
        <OnCheckoutComplete mdxType="OnCheckoutComplete" />
      </Item>
      <Item title='onBeforeClientSessionUpdate' subtitle='() => void' mdxType="Item">
        Called when the client session is in the process of being updated. Use it to show a loading indicator on your app.
      </Item>
      <Item title='onClientSessionUpdate' subtitle='(clientSession: PrimerClientSession) => void' mdxType="Item">
        Called when the client session has been updated by the checkout. Returns the updated client session which can be
        used to inform your UI. For example updating tax, shipping or discount amounts displayed to your customers.
      </Item>
      <Item title='onBeforePaymentCreate' subtitle='(checkoutPaymentMethodData: PrimerCheckoutPaymentMethodData, handler: PrimerPaymentCreationHandler) => void' mdxType="Item">
        <OnBeforePaymentCreate mdxType="OnBeforePaymentCreate" />
      </Item>
      <Item title='onPreparationStart' subtitle='(paymentMethodType: string) => void' mdxType="Item">
        This method will be called when the SDK starts preparing to tokenize the payment method.
      </Item>
      <Item title='onPaymentMethodShow' subtitle='(paymentMethodType: string) => void' mdxType="Item">
        Called when the payment method is displayed.
      </Item>
    </Group>
  </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      